module.exports = "/images/Header Logo.svg?a3c6e74398721bf84e430569ef89ca1d";